var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-full pt-2 overflow-visible",attrs:{"id":"settings-list"}},[_c('side-list',{attrs:{"items":_vm.items,"selected-id":_vm.selectedLabel,"with-scrollbar":false,"id-key":"label"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var isItemSelected = ref.isItemSelected;
return [_c('settings-list-item',{attrs:{"is-selected":isItemSelected,"label":item.label,"url":item.url,"route":item.route,"icon":item.icon}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }